import Request from './request';
//import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
//import Polygon from "@arcgis/core/geometry/Polygon";
import { loadModules } from 'esri-loader';
import printConfig from '../defaults/Print.json';
import originFields from '../defaults/PointOfOriginFields.json'
import consts from '../defaults/Enums.json'
import { formatIdentifierForApi, getPolygonCreateDate } from '../utils/incidentHelper';

const defaults = {
  apiUrl: 'api',
  portalUrl: '',
  user: '',
  folder: ''
};

const Landowners = [
  {
    LandownerCategoryID: 1,
    Name: "Bureau of Indian Affairs",
    Code: "BIA",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 2,
    Name: "Bureau of Land Management",
    Code: "BLM",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 3,
    Name: "Bureau of Reclamation",
    Code: "BOR",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 4,
    Name: "Department of Defense",
    Code: "DOD",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 5,
    Name: "Department of Energy",
    Code: "DOE",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 6,
    Name: "National Park Service",
    Code: "NPS",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 7,
    Name: "US Forest Service",
    Code: "USFS",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 8,
    Name: "US Fish and Wildlife Service",
    Code: "USFWS",
    LandownerKind: "Federal"
  },
  {
    LandownerCategoryID: 9,
    Name: "Foreign Government",
    Code: "Foreign",
    LandownerKind: "Private"
  },
  {
    LandownerCategoryID: 10,
    Name: "Tribal Government (non-trust lands) or Alaska Native Corporation",
    Code: "Tribal",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 11,
    Name: "City or Equivalent Government",
    Code: "City",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 12,
    Name: "County or Equivalent Government",
    Code: "County",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 13,
    Name: "State or Equivalent Government",
    Code: "State",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 14,
    Name: "Individual or Private Corporation",
    Code: "Private",
    LandownerKind: "Private"
  },
  {
    LandownerCategoryID: 15,
    Name: "Alaska Native Claims Settlement Act",
    Code: "ANCSA",
    LandownerKind: "Private"
  },
  {
    LandownerCategoryID: 16,
    Name: "Other Local",
    Code: "OthLoc",
    LandownerKind: "Other"
  },
  {
    LandownerCategoryID: 18,
    Name: "Other Federal",
    Code: "OthFed",
    LandownerKind: "Federal"
  }
];

const StateAbbreviation = 'STATE_ABBR';

export default class Api {

  constructor(params) 
  {
    this.props = Object.assign({}, defaults, params);
    this.request = new Request(this.props.token);
    this.basename = process.env.PUBLIC_URL;
  }

  setSortField(sortField) {
    this.props.sortField = sortField;
  }

  setSortDesc(sortDesc) {
    this.props.sortDesc = sortDesc;
  }
  setPortalUrl(url) {
    this.props.portalUrl = url;
  }

  setOriginLayerUrl(url) {
    this.props.originLayerUrl = url;
  }

  setRelationshipLayerUrl(url) {
    this.props.relationshipLayerUrl = url;
  }

  setJurisdictionalFeatureLayerUrl(url) {
    this.props.jurisdictionalFeatureLayerUrl = url;
  }

  setPerimetersLayerUrl(url) {
    this.props.perimetersLayerUrl = url;
  }

  setFinalPerimetersLayerUrl(url) {
    this.props.finalPerimetersLayerUrl = url;
  }

  setResourceLayerUrl(url) {
    this.props.resourceLayerUrl = url;
  }

  setCapabilityRequestLayerUrl(url) {
    this.props.capabilityRequestLayerUrl = url;
  }

  setPerimeterDeleteLayerUrl(url) {
    this.props.perimeterDeleteLayerUrl = url;
  }

  setAcresByJurisdictionUrl(url) {
    this.props.acresByJurisdictionUrl = url;
  }

  setOriginLayerToken(token) {
    this.props.setOriginLayerToken = token;
  }

  setOriginApiUrl(url) {
    this.props.originApiUrl = url;
  }

  setJurisdictionalFeatureLayerToken(token) {
    this.props.setJurisdictionalFeatureLayerToken = token;
  }

  setPerimetersLayerToken(token) {
    this.props.setPerimetersLayerToken = token;
  }

  setRelationshipLayerToken(token) {
    this.props.setRelationshipLayerToken = token;
  }

  setAcresByJurisdictionToken(token) {
    this.props.setAcresByJurisdictionToken = token;
  }

  setFinalPerimetersLayerToken(token) {
    this.props.setFinalPerimetersLayerToken = token;
  }


  setPerimeterDeleteLayerToken(token) {
    this.props.setPerimeterDeleteLayerToken = token;
  }

  setOriginApiToken(token) {
    this.props.setOriginApiToken = token;
  }
  setAuth(user) {
    this.props.user = user;
  }

  setToken(token) {
    this.props.token = token;
  }

  getToken() {
    return this.props.token;
  }

  setCredential(credential) {
    this.props.credential = credential;
  }

  getCredential() {
    return this.props.credential;
  }

  getUsername() {
    return this.props.user.username;
  }

  getPortalUrl() {
    return this.props.portalUrl;
  }

  getPerimeterDeleteLayerUrl() {
    return this.props.perimeterDeleteLayerUrl;
  }

  getOriginLayerUrl() {
    return this.props.originLayerUrl;
  }

  getOriginApiUrl() {
    return this.props.originApiUrl;
  }

  getRelationshipLayerUrl() {
    return this.props.relationshipLayerUrl;
  }

  getJurisdictionalFeatureLayerUrl() {
    return this.props.jurisdictionalFeatureLayerUrl;
  }

  getPerimetersLayerUrl() {
    return this.props.perimetersLayerUrl;
  }

  getFinalPerimetersLayerUrl() {
    return this.props.finalPerimetersLayerUrl;
  }

  getResourceLayerUrl() {
    return this.props.resourceLayerUrl;
  }

  getCapabilityRequestLayerUrl() {
    return this.props.capabilityRequestLayerUrl;
  }

  getAcresByJurisdictionUrl() {
    return this.props.acresByJurisdictionUrl;
  }

  getOriginLayerToken() {
    return this.props.setOriginLayerToken;
  }

  getPerimetersLayerToken() {
    return this.props.setPerimetersLayerToken;
  }
  getFinalPerimetersLayerToken() {
    return this.props.setFinalPerimetersLayerToken;
  }

  getJurisdictionalFeatureLayerToken() {
    return this.props.setJurisdictionalFeatureLayerToken;
  }

  getRelationshipLayerToken() {
    return this.props.setRelationshipLayerToken;
  }

  getAcresByJurisdictionToken() {
    return this.props.setAcresByJurisdictionToken;
  }

  getOriginApiToken() {
    return this.props.setOriginApiToken;
  }

  getApiUrl() {
    return `${window.location.protocol}//${window.location.host}${this.basename}/${this.props.apiUrl}`;
  }

  getAppConfig() {
    return new Promise((resolve, reject) => {
      this.request.makeRequest({
        url: `${this.basename}/config.json`,
        method: 'get'
      }).then(resp => {
        this.setPortalUrl(resp.portalUrl)
        resolve(resp)
      });
    });
  }

  getUserGroups(userName, useWVLogin) {
    return new Promise((resolve, reject) => {

      const portalToUse = (useWVLogin) ? "https://wvdof.maps.arcgis.com" : this.getPortalUrl();
      this.request.makeRequest({
        url: `${portalToUse}/sharing/rest/community/users/${userName}`,
        method: 'post',
        data: { f: 'json', token: this.getToken() }
      }).then(
        resp => resolve(resp),
        error => reject(error)
      )
    });
  }

  postStateUpload(file, indicesOutsideBuffer, selectedCategory) {
    return new Promise((resolve, reject) => {
      //TODO: Fix URL

      const uploadUsername = this.getUsername();

      this.request.uploadFile(`${this.getOriginApiUrl()}/FireOccurenceRecords/UploadStateFile`, file, indicesOutsideBuffer, uploadUsername, selectedCategory)
        .then(response => {
          resolve(response);
        }
        )
    });
  }

  deriveAcresByJurisdiction(perimeter) {
    return new Promise((resolve, reject) => {
      loadModules(['esri/geometry/geometryEngine', 'esri/geometry/Polygon']).then(([GeometryEngine, Polygon]) => {
        let perimeterPolygon = new Polygon(perimeter);

        this.request.makeRequest({
          url: `${this.getJurisdictionalFeatureLayerUrl()}/query`,
          method: 'post',
          hideCredentials: true,
          data: {
            f: 'json',
            outFields: ['*'],
            returnGeometry: true,
            geometry: JSON.stringify(perimeterPolygon.extent),
            spatialRel: 'esriSpatialRelIntersects',
            geometryType: 'esriGeometryEnvelope',
            outSR: 4326,
            inSR: 4236,
            token: this.getToken()
          }
        }).then(results => {
          let response = [];
          if (results.features && results.features.length > 0) {

            const distinctLandCats = [...new Set(results.features.map(x => x.attributes.LandownerCategory))];

            for (let i = 0; i < distinctLandCats.length; i++) {
              let landCatResults = [...new Set(results.features.filter(result => result.attributes.LandownerCategory === distinctLandCats[i]))];

              const landownerCategory = landCatResults[0].attributes.LandownerCategory;
              const landownerKind = landCatResults[0].attributes.LandownerKind;

              //let unionedPrivate = GeometryEngine.union(privateRecords.map(a => a.intersection));
              let landCatIntersections = [];
              let totalForLandCat = 0;

              for (let p = 0; p < landCatResults.length; p++) {
                if (GeometryEngine.intersects(perimeterPolygon, landCatResults[p].geometry)) {
                  let intersection = GeometryEngine.intersect(perimeterPolygon, landCatResults[p].geometry);
                  let calculatedAcres = GeometryEngine.geodesicArea(intersection, 'acres');

                  landCatIntersections.push(intersection);
                  totalForLandCat += calculatedAcres;
                }
              }

              const unionedForLandCat = (landCatIntersections && landCatIntersections.length > 0) ? GeometryEngine.union(landCatIntersections) : null;

              if (totalForLandCat > 0) {
                response.push(
                  {
                    geometry: unionedForLandCat,
                    Acres: totalForLandCat.toFixed(2),
                    Category:
                    {
                      Code: landownerCategory,
                      LandownerKind: landownerKind,
                      LandownerCategoryID: Landowners.find(landowner => (landowner.Code === landownerCategory)).LandownerCategoryID
                    }
                  });
              }
            }
          }
          resolve(response);
        }
        );
      }
      );
    });
  }

  generateFeatureFromShapefile(params, file) {
    return new Promise((resolve, reject) => {
      //TODO: Fix URL
      this.request.upload("https://nifc.maps.arcgis.com/sharing/rest/content/features/generate?filetype=shapefile&publishParameters=%7B%22name%22%3A%22perimeters%22%2C%22targetSR%22%3A%7B%22latestWkid%22%3A3857%2C%22wkid%22%3A102100%7D%2C%22maxRecordCount%22%3A1000%2C%22enforceInputFileSizeLimit%22%3Atrue%2C%22enforceOutputJsonSizeLimit%22%3Atrue%2C%22generalize%22%3Afalse%2C%22maxAllowableOffset%22%3A10%2C%22reducePrecision%22%3Afalse%2C%22numberOfDigitsAfterDecimal%22%3A0%7D&f=json", file)
        .then(response => {
          if (response.featureCollection && response.featureCollection.layers.length > 0 && response.featureCollection.layers[0].featureSet.features.length > 0) 
          {
            const geom = response.featureCollection.layers[0].featureSet.features.find(feature => (feature.geometry !== null && feature.geometry !== undefined));
            if (geom) 
            {
              resolve(geom.geometry);
            }
            else {
              reject();
            }
          }
          else {
            reject();
          }
        })
    });
  }

  
  getIrwinIdsForPerimeterForGeometry(extent, resultOffset, results) {
    return new Promise((resolve, reject) => {

      const whereClause = "DeleteThis IS NULL OR DeleteThis = 'NO' AND IRWINID IS NOT NULL AND IRWINID <> ''";

      this.request.makeRequest({
        url: `${this.getPerimetersLayerUrl()}/query`,
        method: 'get',
        hideCredentials: true,
        data: {
          f: 'json',
          outFields: 'IRWINID',
          where: whereClause,
          returnGeometry: false,
          resultOffset: resultOffset,
          geometry: JSON.stringify(extent),
          geometryType: 'esriGeometryEnvelope',
          returnDistinctValues: true,
          token: this.getPerimetersLayerToken()
        }
      }).then(
        resp => {
          if (resp.exceededTransferLimit) {
            let newResults = results.concat(resp.features);
            this.getIrwinIdsForPerimeterForGeometry(extent, (newResults.length), newResults).then(finalResults => { resolve(finalResults) });
          }
          else {
            let finalResults = results.concat(resp.features);
            resolve(finalResults);
          }
        },
        error => reject(error)
      )
    });
  }

  getIncidentCountForQuery(geom, whereClause, queryUrl) 
  {
    return new Promise((resolve, reject) => {
      const stringGeom = JSON.stringify(geom);

      this.request.makeRequest({
        url: queryUrl,
        method: 'post',
        hideCredentials: true,
        data: {
          f: 'json',
          where: whereClause,
          returnGeometry: false,
          returnCountOnly: true,
          geometry: stringGeom,
          spatialRel: 'esriSpatialRelIntersects',
          geometryType: (stringGeom.includes("rings")) ? 'esriGeometryPolygon' : 'esriGeometryEnvelope',
          token: this.getToken()
        }
      }).then(
        resp => 
        {
          resolve(resp.count);
        },
        error => reject(error)
      )
    });
  }
// window.api.GetForIDsForQuery(extent, resultOffset, results, whereClause, url).then(results => {
  GetForIDsForQuery(filterGeometry, resultOffset, results, whereClause, queryUrl) 
  {
    return new Promise((resolve, reject) => {

      const stringGeom = JSON.stringify(filterGeometry);
      this.request.makeRequest({
        url: queryUrl,
        method: 'post',
        hideCredentials: true,
        data: {
          f: 'json',
          outFields: 'FireOccurenceRecordID',
          where: whereClause,
          returnGeometry: false,
          resultOffset: resultOffset,
          geometry: stringGeom,
          geometryType: (stringGeom.includes("rings")) ? 'esriGeometryPolygon' : 'esriGeometryEnvelope',
          spatialRel: 'esriSpatialRelIntersects',
          token: this.getToken()
        }
      }).then(
        resp => {
          if (resp.exceededTransferLimit)
          {
            let newResults = results.concat(resp.features);
            this.GetForIDsForQuery(filterGeometry, (newResults.length), newResults, whereClause, queryUrl).then(finalResults => { resolve(finalResults) });
          }
          else 
          {
            let finalResults = results.concat(resp.features);

            let forIds = [];
            for (let i = 0; i < finalResults.length; i++) 
            {
              forIds.push(finalResults[i].attributes.FireOccurenceRecordID);
            }
            resolve(forIds);
          }
        },
        error => reject(error)
      )
    });
  }


  getIncidentsForQuery(geom, resultOffset, results, whereClause, queryUrl, maxRecords) 
  {
    return new Promise((resolve, reject) => {
      const stringGeom = JSON.stringify(geom);
      const sortClause = ((this.props.sortField) ? this.props.sortField : "IncidentSize") + ((this.props.sortDesc) ? " DESC" : " ASC");
      this.request.makeRequest({
        url: queryUrl,
        method: 'post',
        hideCredentials: true,
        data: {
          f: 'json',
          outFields: originFields.requiredOutFields,
          where: whereClause,
          maxRecordCount: maxRecords,
          returnGeometry: true,
          resultOffset: resultOffset,
          outSR: 3857,
          orderByFields: sortClause,
          geometry: stringGeom,
          geometryType: (stringGeom.includes("rings")) ? 'esriGeometryPolygon' : 'esriGeometryEnvelope',
          token: this.getToken()
        }
      }).then(
        resp => {
          if (resp.exceededTransferLimit && ((resp.features.length + results.length) < maxRecords))
          {
            let newResults = results.concat(resp.features);
            this.getIncidentsForQuery(stringGeom, (newResults.length), newResults, whereClause, queryUrl, maxRecords).then(finalResults => { resolve(finalResults) });
          }
          else 
          {
            let finalResults = results.concat(resp.features);
            if (finalResults.length > maxRecords) 
            {
              finalResults = finalResults.slice(0, maxRecords);
            }
            resolve(finalResults);
          }
        },
        error => reject(error)
      )
    });
  }

  getIrwinIdsForCertifiedPerimetersForGeometry(extent, resultOffset, results) {
    return new Promise((resolve, reject) => {

      const whereClause = "IRWINID IS NOT NULL";

      this.request.makeRequest({
        url: `${this.getFinalPerimetersLayerUrl()}/query`,
        method: 'get',
        hideCredentials: true,
        data: {
          f: 'json',
          outFields: '*',
          where: whereClause,
          returnGeometry: false,
          resultOffset: resultOffset,
          geometry: JSON.stringify(extent),
          geometryType: 'esriGeometryEnvelope',
          token: this.getFinalPerimetersLayerToken()
        }
      }).then(
        resp => {
          if (resp.exceededTransferLimit) {
            let newResults = results.concat(resp.features);
            this.getIrwinIdsForCertifiedPerimetersForGeometry(extent, (newResults.length), newResults).then(finalResults => { resolve(finalResults) });
          }
          else {
            let finalResults = results.concat(resp.features);
            resolve(finalResults);
          }
        },
        error => reject(error)
      )
    });
  }

  getIdsForPerimeterFilters(mapMethod, featureStatus, featureAccess, extent, resultOffset, results) {
    return new Promise((resolve, reject) => {

      let clauses = [];
      if (mapMethod) {
        clauses.push("MapMethod = '" + mapMethod + "'");
      }

      if (featureStatus) {
        clauses.push("FeatureStatus = '" + featureStatus + "'");
      }

      if (featureAccess) {
        clauses.push("FeatureAccess = '" + featureAccess + "'");
      }

      let whereClause = clauses.join(' AND ');
      whereClause += " AND (DeleteThis IS NULL OR DeleteThis = 'NO' AND IRWINID IS NOT NULL AND IRWINID <> '')";
      this.request.makeRequest({
        url: `${this.getPerimetersLayerUrl()}/query`,
        method: 'get',
        hideCredentials: true,
        data: {
          f: 'json',
          outFields: 'IRWINID',
          where: whereClause,
          returnGeometry: false,
          resultOffset: resultOffset,
          geometry: JSON.stringify(extent),
          geometryType: 'esriGeometryEnvelope',
          returnDistinctValues: true,
          token: this.getPerimetersLayerToken()
        }
      }).then(
        resp => {
          if (resp.exceededTransferLimit) {
            let newResults = results.concat(resp.features);
            this.getIdsForPerimeterFilters(mapMethod, featureStatus, featureAccess, extent, (newResults.length), newResults).then(finalResults => { resolve(finalResults) });
          }
          else {
            let finalResults = results.concat(resp.features);
            resolve(finalResults);
          }
        },
        error => reject(error)
      )
    });
  }

  getIdsForCapabilityRequests(fulfillmentStatus) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getCapabilityRequestLayerUrl()}/query`,
        method: 'get',
        data: {
          f: 'json',
          outFields: 'IRWINID',
          where: `(FulfillmentStatus = '${fulfillmentStatus}')`,
          returnGeometry: false,
          returnDistinctValues: true,
          token: this.getOriginApiToken()
        }
      }).then(
        resp => {
          resolve(resp.features)
        },
        error => reject(error)
      )
    });
  }

  getUrlForPerimeterSource(perimeterSource) {
    switch (perimeterSource) {
      case consts.perimeterSource.nifs:
        return this.getPerimetersLayerUrl();

      case consts.perimeterSource.fireHistoryFeatureService:
        return this.getFireHistoryFeatureLayerUrl();

      case consts.perimeterSource.finalFireFeatureService:
        return this.getFinalPerimetersLayerUrl();
      default:
        console.log("ERROR: Invalid Perimeter Source provided: " + perimeterSource);
        return "";
    }
  }

  getTokenForPerimeterSource(perimeterSource) {
    switch (perimeterSource) {
      case consts.perimeterSource.nifs:
        return this.getPerimetersLayerToken();

      case consts.perimeterSource.fireHistoryFeatureService:
        return this.getFireHistoryFeatureLayerToken();

      case consts.perimeterSource.finalFireFeatureService:
        return this.getFinalPerimetersLayerToken();
      default:
        console.log("ERROR: Invalid Perimeter Source provided: " + perimeterSource);
        return "";
    }
  }

  addNewPerimeter(perimeterFeature, incidentAttributes) {
    return new Promise((resolve, reject) => {

      loadModules([
        'esri/geometry/support/webMercatorUtils'
      ])
        .then(([WebMercatorUtils]) => {

          this.deriveCalculatedAcres(perimeterFeature).then(resp => {

            const perimeterGeomWGS84 = WebMercatorUtils.webMercatorToGeographic(perimeterFeature.geometry);
            perimeterFeature.geometry = perimeterGeomWGS84;

            const calculatedAcres = resp;
            const username = this.getUsername();
            const polygonCreateDate = getPolygonCreateDate(incidentAttributes);

            let jsonFeature = JSON.stringify(perimeterFeature);

            this.request.makeRequest({
              url: `${this.getOriginApiUrl()}/Perimeters/AddNewPerimeter`,
              method: 'post',
              hideCredentials: true,
              data: {
                userToken: this.getOriginLayerToken(),
                perimeterFeature: jsonFeature,
                polygonCreateDate: polygonCreateDate,
                forID: incidentAttributes[originFields.forId],
                username: username,
                calcedAcres: calculatedAcres
              }
            }).then(
              resp => {
                resolve(resp)
              },
              error => reject(error)
            )
          });
        });
    });
  }

  updateIrwinIDForFireHistory (irwinID, objectID)  
  {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/Perimeters/UpdateIrwinIDForFireHistory`,
        method: 'post',
        hideCredentials: true,
        data:
        { 
          irwinID: formatIdentifierForApi(irwinID),
          objectID: objectID,
          userToken: this.getOriginLayerToken()
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }

  updateIrwinIDForNifs(irwinID, objectID)  {

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/Perimeters/UpdateIrwinIDForNIFS`,
        method: 'post',
        hideCredentials: true,
        data:
        { 
          irwinID: formatIdentifierForApi(irwinID),
          objectID: objectID,
          userToken: this.getOriginLayerToken()
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }

  certifyPerimeter(perimeterFeature, forId) {
    return new Promise((resolve, reject) => {

      let jsonFeature = JSON.stringify(perimeterFeature);

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/Perimeters/CertifyPerimeter`,
        method: 'post',
        hideCredentials: true,
        data:
        {
          feature: jsonFeature,
          forId: JSON.stringify(forId),
        }
      }).then(
        resp => {
          let feature =
          {
            perimeter: resp.Perimeter
          }
          resolve(feature)
        },
        error => reject(error)
      )
    });
  }

  decertifyPerimeter(perimeterFeature, forId) {
    return new Promise((resolve, reject) => {

      let jsonFeature = JSON.stringify(perimeterFeature);

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/Perimeters/DecertifyPerimeter`,
        method: 'post',
        hideCredentials: true,
        data:
        {
          feature: jsonFeature,
          forID: JSON.stringify(forId),
          userToken: this.getOriginLayerToken()
        }
      }).then(
        resp => {
          resolve(resp.Perimeter)
        },
        error => reject(error)
      )
    });
  }

  deriveCalculatedAcres(perimeter) {
    return new Promise((resolve) => {
      loadModules(['esri/geometry/geometryEngine', 'esri/geometry/Polygon']).then( ([geometryEngine, Polygon]) =>
      {
      const perimeterPolygon = new Polygon(perimeter.geometry);
      let calculatedAcres = geometryEngine.geodesicArea(perimeterPolygon, 'acres');
      if (calculatedAcres < 0.01) 
        {
        calculatedAcres = 0.01;
      }
      resolve(calculatedAcres.toFixed(2));
      });
    });
  }

  validateLatLong (lat, long) {

    return new Promise((resolve, reject) => {
      loadModules([
        'esri/geometry/support/webMercatorUtils',
        'esri/geometry/geometryEngine',
        'esri/geometry/Polygon',
        'esri/geometry/Point', 
        'esri/geometry/SpatialReference'
      ])
        .then(([WebMercatorUtils, geometryEngine, Polygon, Point, SpatialReference]) => {
          var xy = WebMercatorUtils.lngLatToXY(long, lat);

          const incidentGeometry = new Point({
            x: xy[0],
            y: xy[1],
            spatialReference: new SpatialReference(102100)
        });

          const bufferedInput = geometryEngine.geodesicBuffer(incidentGeometry, 10, "miles");

          //TODO: Fix Url
          this.request.makeRequest({
            url: `https://services3.arcgis.com/T4QMspbfLg3qTGWY/ArcGIS/rest/services/US_States_and_Terrorities_TIGER_Line_2017/FeatureServer/0/query`,
            method: 'post',
            hideCredentials: true,
            data: {
              f: 'json',
              //geometry: xy[0] + ',' + xy[1],
              geometry: JSON.stringify(bufferedInput.toJSON()),
              geometryType: 'esriGeometryPolygon',
              spatialRel: 'esriSpatialRelIntersects',
              outFields: ['FID'],
              returnGeometry: false,
              token: this.getToken()
            }
          }).then(
            resp => {
              if (resp.features !== null && resp.features.length > 0) 
              {
                resolve(true);
              } 
              else 
              {
                resolve(false);
              }
            },
            error => reject(error)
          )
        });
    });
  }

  
getStateFromOrigin(lat, long) {

  const StateAbbreviation = 'STUSPS';

  return new Promise((resolve, reject) => {

        //TODO: Fix Url
        this.request.makeRequest({
          url: `https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/US_State_and_County/FeatureServer/1/query`,
          method: 'get',
          hideCredentials: true,
          data: {
            f: 'json',
            geometry: long + ',' + lat,
            geometryType: 'esriGeometryPoint',
            spatialRel: 'esriSpatialRelIntersects',
            outFields: [StateAbbreviation],
            returnGeometry: false
          }
        }).then(
          resp => 
          {
            if (resp.features !== null && resp.features.length > 0) 
            {
              resolve(resp.features[0].attributes[StateAbbreviation]);
            } else 
            {
              resolve(null);
            }
          },
          error => reject(error)
        )

  });
}

  getUnitId(unitIdString) {
    //TODO: Fix URL

    return new Promise((resolve, reject) => {
      //https://unitid.nifc.gov/ords/uat/nifc/units/UnitIDActiveSingleUnit_json/USIDbod
      this.request.makeRequest({
        url: `https://unitid.nifc.gov/ords/prd/nifc/units/UnitIDActiveSingleUnit_json/US` + unitIdString,
        method: 'get',
        hideCredentials: true
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }



  deriveLandownerCategory(lat, long) {
    return new Promise((resolve, reject) => {
      loadModules([
        'esri/geometry/support/webMercatorUtils'
      ])
        .then(([WebMercatorUtils]) => {

          var originVal = WebMercatorUtils.lngLatToXY(long, lat);

          this.request.makeRequest({
            url: `${this.getJurisdictionalFeatureLayerUrl()}/query`,
            method: 'get',
            hideCredentials: true,
            data: {
              f: 'json',
              geometry: `${originVal[0]},${originVal[1]}`,
              geometryType: 'esriGeometryPoint',
              outFields: ['LandownerKind, LandownerCategory'],
              returnGeometry: false,
              token: this.getJurisdictionalFeatureLayerToken()
            }
          }).then(
            resp => {
              if (resp.features !== null && resp.features.length > 0) {
                resolve(resp.features[0].attributes);
              }
            },
            error => reject(error)
          )
        });
    });

  }

 deriveFuelModel(lat, long, state) {

    //TODO: Fix URLs
    return new Promise((resolve, reject) => {
      loadModules([
        'esri/geometry/Point', 'esri/geometry/SpatialReference', 'esri/geometry/projection'
      ])
        .then(([Point, SpatialReference, projection]) => {

          let url = "https://lfps.usgs.gov/arcgis/rest/services/Landfire_LF220/US_220F40_22/ImageServer/identify";

          const geographicPoint = new Point
          ({
            latitude: lat,
            longitude: long,
            spatialReference: new SpatialReference(4326)
          });

          projection.load().then(() => {

            var outputSpatialReference;
            switch (state) 
            {
              case "US-AK":
                url = "https://lfps.usgs.gov/arcgis/rest/services/Landfire_LF220/AK_220F40_22/ImageServer/identify";
                outputSpatialReference= new SpatialReference({
                  wkid: 102006
                 });
                break;

              case "US-HI":
                url = "https://lfps.usgs.gov/arcgis/rest/services/Landfire_LF220/HI_220F40_22/ImageServer/identify";
                outputSpatialReference= new SpatialReference({
                  wkt: 'PROJCS["Hawaii_Albers_Equal_Area_Conic",GEOGCS["GCS_North_American_1983",DATUM["D_North_American_1983",SPHEROID["GRS_1980",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Albers"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",-157.0],PARAMETER["Standard_Parallel_1",8.0],PARAMETER["Standard_Parallel_2",18.0],PARAMETER["Latitude_Of_Origin",13.0],UNIT["Meter",1.0]],VERTCS["unknown",VDATUM["unknown"],PARAMETER["Vertical_Shift",0.0],PARAMETER["Direction",1.0],UNIT["Meter",1.0]]'
                 });
                break;

              default:
                outputSpatialReference= new SpatialReference({
                  wkt: 'PROJCS["NAD_1983_Albers",GEOGCS["GCS_North_American_1983",DATUM["D_North_American_1983",SPHEROID["GRS_1980",6378137.0,298.257222101]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Albers"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["central_meridian",-96.0],PARAMETER["Standard_Parallel_1",29.5],PARAMETER["Standard_Parallel_2",45.5],PARAMETER["latitude_of_origin",23.0],UNIT["Meter",1.0]]'
                 });
            }

        
          const projectedPoint = projection.project(geographicPoint, outputSpatialReference);

          this.request.makeRequest({
            url: url,
            method: 'get',
            data: {
              f: 'json',
              geometry: `${projectedPoint.x},${projectedPoint.y}`,
              geometryType: 'esriGeometryPoint',
              returnPixelValues: 'true',
              returnGeometry: false,
            }
          }).then(
            resp => {

              if (resp !== null && resp.value != null) {
                resolve(resp.value); //TODO: Fix Hardcode
              }
            },
            error => reject(error)
          )
        });
      });
    });
  }

  //[Route("api/FireOccurenceRecords/UnspliceRecord")]
  //public async Task<IHttpActionResult> UnspliceRecord(Token userToken, int occurenceRecordID, string username, int userId)
  
    despliceRecord(incidentId) {
        return new Promise((resolve, reject) => {
          
        this.request.makeRequest({
          url: `${this.getOriginApiUrl()}/FireOccurenceRecords/UnspliceRecord`,
          method: 'get',
          hideCredentials: true,
          data: {
            f: 'json',
            occurenceRecordID: incidentId,
            userToken: this.getOriginLayerToken(),
            username: this.getUsername()
          }
        }).then(
          resp => {
            resolve()
          },
          error => reject(error)
        )
      });
    }

  loadFullIncidentFromApi(incidentId) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetFOR/` + formatIdentifierForApi(incidentId),
        method: 'get',
        hideCredentials: true
      }).then(
        resp => {
          let feature = {
            attributes: Object.assign({}, resp.FireOccurenceRecord,
              {
                "_pointGeometryLatitude": resp.FireOccurenceRecord.y,
                "_pointGeometryLongitude": resp.FireOccurenceRecord.x
              }
            ),
            perimeter: resp.Perimeter,
            perimeterAcreage: resp.AcreagePackage,
            knownUnitIds: resp.KnownUnitIDs,
            irwinRelationshipRecords: resp.IrwinRelationshipRecords,
            initialResources: resp.InitialResources,
            mergedIncidents: resp.MergedRecords,
            mergedPerimeters: resp.MergedPerimeters
          }
          resolve(feature)
        },
        error => reject(error)
      )
    });
  }

  getIncident(incidentId) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/query`,
        method: 'get',
        data: {
          f: 'json',
          outFields: '*',
          where: `(${originFields.irwinId} = '${incidentId}' AND ${originFields.isQuarantined} IN (0,1) AND IsValid = 1)`,
          returnGeometry: true,
          token: this.getOriginApiToken()
        }
      }).then(
        resp => {
          resolve(resp.features[0])
        },
        error => reject(error)
      )
    });
  }

  getStateForUpload(stateAbbr)
  {
    //TODO: Fix URL
    return new Promise((resolve, reject) => {
        this.request.makeRequest({
          url: `https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/US_State_and_County/FeatureServer/1/query`,
          method: 'get',
          hideCredentials: true,
          data: {
            f: 'json',
            where: `STUSPS = '${stateAbbr}'`,
            outFields: ['NAME'],
            outSR: 4326,
            returnGeometry: true
          }
        }).then(
          resp =>
          {
             if (resp.features !== null && resp.features.length > 0)
             {
               resolve(resp.features[0]);
             }
          },
          error => reject(error)
          )
    });
  } 


  mergeRecord(childId, parentId, mergeDate, mergeComments, shouldMergePerimeters, assignAcreage, childPerimeter, parentPerimeter) {
    return new Promise((resolve, reject) => {
      loadModules(['esri/geometry/geometryEngine', 'esri/geometry/Polygon']).then(([GeometryEngine, Polygon]) => {
        
        debugger;
        let unionedPerimeter = null;
        let allPerimeters = [];
        if (shouldMergePerimeters) 
        {
          allPerimeters.push(new Polygon(childPerimeter.geometry));
          allPerimeters.push(new Polygon(parentPerimeter.geometry));

          unionedPerimeter = GeometryEngine.union(allPerimeters);

          parentPerimeter.geometry = unionedPerimeter.toJSON();
        }

        this.request.makeRequest({
          url: `${this.getOriginApiUrl()}/FireOccurenceRecords/MergeRecord`,
          method: 'post',
          hideCredentials: true,
          data: {
            f: 'json',
            mergeChildFireOccurenceRecordID: childId,
            mergeParentFireOccurenceRecordID: parentId,
            username: this.getUsername(),
            mergedOnDateTime: mergeDate,
            mergeNotes: mergeComments,
            shouldMergePerimeters: shouldMergePerimeters,
            assignAcreage: assignAcreage,
            mergedPerimeter: JSON.stringify(parentPerimeter)
          }
        }).then(
          resp => {
            resolve(resp);
          },
          error => reject(error)
        )
      });
    });
  }
  
    searchAdminIncident (identifer, searchValue) {
      return new Promise((resolve, reject) => {

        this.request.makeRequest({
          url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetEditPackageForIncident`,
          method: 'post',
          hideCredentials: true,
          data: {
            f: 'json',
            identifer: JSON.stringify(identifer),
            identifierName: JSON.stringify(searchValue),
            username: this.getUsername()
          }
        }).then(
          resp =>
          {
            resolve(resp);
          },
          error => reject(error)
          )
    });
    }
    
    getMergePartner (id, identifier, searchValue) {
      return new Promise((resolve, reject) => {

        this.request.makeRequest({
          url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetMergePartner`,
          method: 'post',
          hideCredentials: true,
          data: {
            f: 'json',
            id: id,
            identifier: JSON.stringify(identifier),
            identifierName: JSON.stringify(searchValue),
            username: this.getUsername()
          }
        }).then(
          resp =>
          {
            resolve(resp);
          },
          error => reject(error)
          )
    });
    }

    getMissingPerimeterIncidents() {
      return new Promise((resolve, reject) => {
        this.request.makeRequest({
          url: `${this.getOriginApiUrl()}/Reports/GetMissingPerimeterIncidents`,
          method: 'get',
          hideCredentials: true
        }).then(
          resp => {
            resolve(resp);
          },
          error => reject(error)
        )
      });
    }

    getAcreageDiscrepancyData() {
      return new Promise((resolve, reject) => {
        this.request.makeRequest({
          url: `${this.getOriginApiUrl()}/Reports/GetAcreageDiscrepancyData`,
          method: 'get',
          hideCredentials: true
        }).then(
          resp => {
            resolve(resp);
          },
          error => reject(error)
        )
      });
    }

    
  queryNonFederalFireForYear(startYear, endYear) {
    return new Promise((resolve, reject) => {

      this.request.makeCsvRequest({
        url: `${this.getOriginApiUrl()}/Reports/GetNonFederalFires`,
        method: 'get',
        hideCredentials: true,
        data:
        {
          startYear: startYear,
          endYear: endYear
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  queryNonFederalRXFiresForYear(startYear, endYear) {
    return new Promise((resolve, reject) => {

      this.request.makeCsvRequest({
        url: `${this.getOriginApiUrl()}/Reports/GetNonFederalRXFires`,
        method: 'get',
        hideCredentials: true,
        data:
        {
          startYear: startYear,
          endYear: endYear
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }
  wvdofLogin (clientId) {

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `https://wvdof.maps.arcgis.com/sharing/oauth2/authorize`,
        method: 'post',
        hideCredentials: true,
        data:
        {
          client_id: clientId,
          response_type: 'token',
          state: {
            portalUrl:"https://wvdof.maps.arcgis.com"
          },
          expiration: 20160,
          redirect_uri: window.location.href
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });

  }
  downloadIncidentData(extent, definitionExpression, fodrIds) {
    return new Promise((resolve, reject) => {

      this.request.makeCsvRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/DownloadRecords`,
        method: 'post',
        hideCredentials: true,
        responseType: 'blob',
        data:
        {
          xmin: extent.xmin,
          ymin: extent.ymin,
          xmax: extent.xmax,
          ymax: extent.ymax,
          definitionExpression: definitionExpression,
          fodrIds: fodrIds
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  getIncidentDataForSummaries(extent, definitionExpression) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetIncidentDataForSummaries`,
        method: 'post',
        hideCredentials: true,
        data:
        {
          xmin: extent.xmin,
          ymin: extent.ymin,
          xmax: extent.xmax,
          ymax: extent.ymax,
          definitionExpression: definitionExpression
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  updatePerimeter(perimeterFeature, incident, geometryChanged, perimeterSource) {

    return new Promise((resolve, reject) => {
      loadModules([
        'esri/geometry/support/jsonUtils',
        'esri/geometry/support/webMercatorUtils',
        'esri/geometry/geometryEngine'
      ])
        .then(([geometryJsonUtils, WebMercatorUtils, GeometryEngine]) => {

          if (geometryChanged) {
            const geomWGS84 = WebMercatorUtils.webMercatorToGeographic(geometryJsonUtils.fromJSON(perimeterFeature.geometry));
            perimeterFeature.geometry = geomWGS84;
          }

          let jsonFeature = JSON.stringify(perimeterFeature);

          this.request.makeRequest({
            url: `${this.getOriginApiUrl()}/Perimeters/UpdatePerimeter`,
            method: 'post',
            hideCredentials: true,
            data:
            {
              userToken: this.getOriginLayerToken(),
              feature: jsonFeature,
              perimeterSource: perimeterSource,
              forID:  JSON.stringify(incident.attributes.FORID) 
            }
          }).then(
            resp => {
              resolve(resp)
            },
            error => reject(error)
          )
        });
    });
  }

  setIncidentValid(fireOccurenceRecordId){
    return new Promise((resolve, reject) => 
    {
      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/RevalidateFOR`,
        method: 'post',
        hideCredentials: true,
        data:
        {
          fireOccurenceRecordId: JSON.stringify(fireOccurenceRecordId),
          username: this.getUsername()
        }
      }).then(
        resp => {
          resolve();
        },
        error => reject(error)
      )
    });
  }
  
  resyncIncident(fireOccurenceRecordId){
    return new Promise((resolve, reject) => 
    {
      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/ResyncFOR`,
        method: 'post',
        hideCredentials: true,
        data:
        {
          fireOccurenceRecordId: JSON.stringify(fireOccurenceRecordId)
        }
      }).then(
        resp => {
          resolve();
        },
        error => reject(error)
      )
    });
  }

  invalidateIncident(forID) {
    return new Promise((resolve, reject) => 
    {
      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/InvalidateFOR`,
        method: 'post',
        hideCredentials: true,
        data:
        {
          forID: JSON.stringify(forID),
          username: this.getUsername()
        }
      }).then(
        resp => {
          resolve();
        },
        error => reject(error)
      )
    });
  }

  /*getPerimeterAcreageIds(landownerCode, acreageOperator, acreageAmount) 
  {
    return new Promise((resolve, reject) => 
    {
      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetPerimeterAcreageIds`,
        method: 'post',
        hideCredentials: true,
        data:
        {
          landownerCode: landownerCode,
          acreageOperator: acreageOperator,
          acreageAmount: acreageAmount
        }
      }).then(
        resp => 
        {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  } */


  saveOccurenceRecords(features) {
    return new Promise((resolve, reject) => {
      loadModules([
        'esri/geometry/support/jsonUtils',
        'esri/geometry/support/webMercatorUtils',
      ])
        .then(([geometryJsonUtils, WebMercatorUtils]) => {

          let featureArray = features.map(feature => {
            let result = feature.attributes;

            //If FireCode has been requested and we don't have a firecode yet, delete the attributes. We might be attempting to overwrite newer Irwin data.
            if ((result[originFields.isFireCodeRequested] === 1) && (!result[originFields.fireCode])) {
              delete result.IsFireCodeRequested;
              delete result.FireCode;
            }
            //set update user
            result.INFORMUserName = this.getUsername();

            if (feature.geometry) {
              const geomWGS84 = WebMercatorUtils.webMercatorToGeographic(geometryJsonUtils.fromJSON(feature.geometry));
              result.geometry = { x: geomWGS84.x, y: geomWGS84.y }
            }

            return result;
          });

          let jsonFeature = JSON.stringify(featureArray[0]);

          this.request.makeRequest({
            url: `${this.getOriginApiUrl()}/FireOccurenceRecords`,
            method: 'post',
            hideCredentials: true,
            data: {
              feature: jsonFeature
              //mercatorX: feature.geometry.x,
              //ercatorY: feature.geometry.y    //TODO: Need to fix this.
            }
          }).then(
            resp => {
              /*
                const results = resp.updateResults.map(result => {
                  if(result.sucess && result.geometry) {
                    result.geometry = WebMercatorUtils.geographicToWebMercator(geometryJsonUtils.fromJSON(result.geometry)).toJSON()
                  }
                  return result;
                });*/
              resolve(resp)
            },
            error => reject(error)
          )
        });
    });
  }

  saveOccurenceRecord(feature, acresByOwnership, unchangedAttributes, clientRecalc) {
    return new Promise((resolve, reject) => {
      loadModules([
        'esri/geometry/support/jsonUtils',
        'esri/geometry/support/webMercatorUtils',
      ])
        .then(([geometryJsonUtils, WebMercatorUtils]) => {

          feature.attributes.INFORMUserName = this.getUsername();

          if (feature.geometry) {
            const geomWGS84 = WebMercatorUtils.webMercatorToGeographic(geometryJsonUtils.fromJSON(feature.geometry));
            feature.attributes.geometry = { x: geomWGS84.x, y: geomWGS84.y }
          }

          let jsonFeature = JSON.stringify(feature.attributes);

          this.request.makeRequest({
            //url: `${this.getOriginApiUrl()}/updateFeatures`,
            url: `${this.getOriginApiUrl()}/FireOccurenceRecords`,
            method: 'post',
            hideCredentials: true,
            data:
            {
              feature: jsonFeature,
              unchangedAttributes: (unchangedAttributes) ? JSON.stringify(unchangedAttributes) : null,
              //mercatorX: mercatorX,
              //mercatorY: mercatorY,
              acresByOwnership: (acresByOwnership) ? JSON.stringify(acresByOwnership) : null,
              clientRecalc: (clientRecalc !== undefined) ? clientRecalc : false
            }
          }).then(
            resp => {

              let feature = {
                attributes: Object.assign({}, resp.FireOccurenceRecord,
                  {
                    "_pointGeometryLatitude": resp.FireOccurenceRecord.y,
                    "_pointGeometryLongitude": resp.FireOccurenceRecord.x
                  }
                ),
                perimeter: resp.Perimeter,
                acresByOwnership: resp.AcresByOwnership,
                perimeterAcreage: resp.AcreagePackage
              }

              /*
                const results = resp.updateResults.map(result => {
                  if(result.sucess && result.geometry) {
                    result.geometry = WebMercatorUtils.geographicToWebMercator(geometryJsonUtils.fromJSON(result.geometry)).toJSON()
                  }
                  return result;
                });*/
              resolve(feature)
            },
            error => reject(error)
          )
        });
    });
  }

  getLastLII (protectingUnitID) {

      return new Promise((resolve, reject) => {

        this.request.makeRequest({
          url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetLLII`,
          method: 'get',
          hideCredentials: true,
          data:
          {
            protectingUnitID: protectingUnitID
          }
        }).then(
          resp => {
            resolve(resp)
          },
          error => reject(error)
        )
      });
  }

  getRelatedRecords(forID) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetRelatedRecords`,
        method: 'get',
        hideCredentials: true,
        data:
        {
          id: formatIdentifierForApi(forID)
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }

  saveSpliceModel(forIdsToSplice, selectedForID, spliceModel, attributesFromLosingFODR) {
    return new Promise((resolve, reject) => {

      loadModules(['esri/geometry/support/webMercatorUtils', 'esri/geometry/Point', 'esri/geometry/SpatialReference'])
        .then(([webMercatorUtils, Point, SpatialReference]) => {

          let geographicPoint = new Point
            ({
              latitude: spliceModel.y,
              longitude: spliceModel.x,
              spatialReference: new SpatialReference(4326)
            });
          
          delete spliceModel.UniquenessRecords;

          let mercatorPoint = webMercatorUtils.geographicToWebMercator(geographicPoint);

          this.request.makeRequest({
            url: `${this.getOriginApiUrl()}/FireOccurenceRecords/SaveSplice`,
            method: 'post',
            hideCredentials: true,
            data: {
              forIdsToSplice: JSON.stringify(forIdsToSplice),
              selectedForID: JSON.stringify(selectedForID),
              spliceModel: JSON.stringify(spliceModel),
              splicedMercatorGeometry: JSON.stringify(mercatorPoint),
              attributesFromLosingFODR: JSON.stringify(attributesFromLosingFODR),
              username: this.getUsername()
            }
          }).then(
            resp => {
              resolve(resp)
            },
            error => reject(error)
          )
        });
    });
  }

  bulkEditIncidents(ids, attributeName, value) {

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/SaveBulkEdits`,
        method: 'post',
        hideCredentials: true,
        data:
        { 
          userToken: this.props.credential.token,
          updateUserName: JSON.stringify(this.getUsername()),
          occurenceRecordIds: JSON.stringify(ids),
          updatedValue: JSON.stringify(value),
          attributeName: JSON.stringify(attributeName)
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }

  shareUserFilter(user,filter) {

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/ShareFilterWithUser`,
        method: 'post',
        hideCredentials: true,
        data:
        { 
          userToken: this.props.credential.token,
          user: JSON.stringify(user),
          filter: JSON.stringify(filter),
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }

  searchForUser(searchString){

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/UserSearch`,
        method: 'post',
        hideCredentials: true,
        data:
        { 
          userToken: this.props.credential.token,
          searchString: JSON.stringify(searchString)
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }

  removeUserLayer(title)
  {

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/RemoveUserLayer`,
        method: 'post',
        hideCredentials: true,
        data:
        { 
          userToken: this.props.credential.token,
          title: JSON.stringify(title)
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }
  addUserLayer(layerObject) {

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/AddUserLayer`,
        method: 'post',
        hideCredentials: true,
        data:
        { 
          userToken: this.props.credential.token,
          userLayer: JSON.stringify(layerObject)
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }
  //createPrescibedEscape
  createPrescibedEscape(ufi, fireOccurenceRecordId) {

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/CreatePrescribedEscape`,
        method: 'get',
        hideCredentials: true,
        data:
        { 
          ufi: ufi,
          rxFireOccurenceId: fireOccurenceRecordId
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }
  
  getIrwinRelationshipPackage(relationshipId, fireOccurenceRecordId) {

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetIrwinRelationshipPackage`,
        method: 'get',
        hideCredentials: true,
        data:
        { 
          relationshipId: relationshipId,
          fireOccurenceRecordId: fireOccurenceRecordId
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }

  getSpliceModel(forId, comparisonForID) {

    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetOccurencesForSplice`,
        method: 'get',
        hideCredentials: true,
        data:
        { //forId, string comparisonForID)
          forId: formatIdentifierForApi(forId),
          comparisonForID: formatIdentifierForApi(comparisonForID)
        }
      }).then(
        resp => {
          resolve(resp)
        },
        error => reject(error)
      )
    });
  }

  //getAppMetrics
  getAppMetrics() {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/GetAppMetrics`,
        hideCredentials: true,
        method: 'get'
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  addIncident(feature, mercatorPoint) {
    return new Promise((resolve, reject) => {

      feature.attributes.INFORMUserName = this.getUsername();

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/FireOccurenceRecords/AddIncident`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          feature: JSON.stringify(feature),
          mercatorX: mercatorPoint.x,
          mercatorY: mercatorPoint.y
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  
  addFilterFromShapefile(params, file, filtername, filterDescription) {
    return new Promise((resolve, reject) => {
      //TODO: Fix URL
      this.request.upload("https://nifc.maps.arcgis.com/sharing/rest/content/features/generate?filetype=shapefile&publishParameters=%7B%22name%22%3A%22perimeters%22%2C%22targetSR%22%3A%7B%22latestWkid%22%3A3857%2C%22wkid%22%3A102100%7D%2C%22maxRecordCount%22%3A1000%2C%22enforceInputFileSizeLimit%22%3Atrue%2C%22enforceOutputJsonSizeLimit%22%3Atrue%2C%22generalize%22%3Atrue%2C%22maxAllowableOffset%22%3A10%2C%22reducePrecision%22%3Afalse%2C%22numberOfDigitsAfterDecimal%22%3A0%7D&f=json", file)
        .then(response => {
          if (response.featureCollection && response.featureCollection.layers.length > 0 && response.featureCollection.layers[0].featureSet.features.length > 0) {
            const geom = response.featureCollection.layers[0].featureSet.features.find(feature => (feature.geometry !== null && feature.geometry !== undefined));
            if (geom) {
              const spatialFilter = {
                attributes: {
                  NifcUsername: this.getUsername(),
                  Filtername: filtername,
                  FilterDescription: filterDescription,
                },
                geometry: geom.geometry
              };

              this.addSpatialFilter(spatialFilter).then(
                response => 
                {
                  resolve(response);
                },
                error => {
                  reject(error);
                }
              );
            }
            else {
              reject();
            }
          }
          else {
            console.log(response);
            reject();
          }
        })
    });
  }


  updateSpatialFilterName (filter) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/UpdateSpatialFilterName`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.props.credential.token,
          filterId: filter.attributes.OBJECTID,
          filterName: filter.attributes.Filtername,
          nifcUsername: this.getUsername(),
        }
      }).then(
        resp => {
          resolve(resp); //this should be id
        },
        error => reject(error)
      )
    });
  }

  deleteSpatialFilter(filterId) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/DeleteSpatialFilter`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.props.credential.token,
          filterId: filterId,
          nifcUsername: this.getUsername(),
        }
      }).then(
        resp => {
          resolve(resp); //this should be id
        },
        error => reject(error)
      )
    });
  }

  addSpatialFilter(spatialFilter) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/AddSpatialFilter`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.props.credential.token,
          spatialFilter: JSON.stringify(spatialFilter)
        }
      }).then(
        resp => {
          resolve(resp); //this should be id
        },
        error => reject(error)
      )
    });
  }

  async getSpatialFilterById(filterId) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/GetSpatialFilterById`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.props.credential.token,
          filterId: filterId
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  getSpatialFiltersForUser() {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/GetSpatialFiltersForUser`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.props.credential.token,
          nifcUsername: this.getUsername()
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  importCustomFiltersFromReduxStore (apiUrl, customFilters) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${apiUrl}/User/ImportCustomFiltersFromReduxStore`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.props.credential.token,
          customFilters: JSON.stringify(customFilters)
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  logTime (fireOccurenceRecordId, seconds, type) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/LogTime`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          fireOccurenceRecordId: fireOccurenceRecordId,
          seconds: seconds,
          type: type
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  saveUserInfo (userSessionInfo) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/UpdateUserInfo`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.props.credential.token,
          userSessionInfo: JSON.stringify(userSessionInfo)
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  getUserSession(apiUrl) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${apiUrl}/User/Login`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.props.credential.token,
          expires: this.props.credential.expires
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  deleteCustomFilter (itemId) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/RemoveCustomFilter`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.getOriginLayerToken(),
          filterId: itemId
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  addCustomFilter(filterName, customFilter) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/AddCustomFilter`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.getOriginLayerToken(),
          filterName: filterName,
          customFilter: JSON.stringify(customFilter)
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  updateCustomFilter(filterId, filterName, customFilter) {
    return new Promise((resolve, reject) => {

      this.request.makeRequest({
        url: `${this.getOriginApiUrl()}/User/UpdateCustomFilter`,
        hideCredentials: true,
        method: 'post',
        data:
        {
          userToken: this.getOriginLayerToken(),
          filterName: filterName,
          filterId: filterId,
          customFilter: JSON.stringify(customFilter)
        }
      }).then(
        resp => {
          resolve(resp);
        },
        error => reject(error)
      )
    });
  }

  async getMapViewImage(args) {
    return new Promise((resolve, reject) => {
      loadModules([
        'esri/tasks/PrintTask',
        'esri/tasks/support/PrintParameters',
        'esri/tasks/support/PrintTemplate'
      ])
        .then(([PrintTask, PrintParameters, PrintTemplate]) => {

          const printUrl = 'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task';
          let printTask = new PrintTask({
            url: printUrl
          });

          let printTemplate = new PrintTemplate(printConfig.template);
          let printParameters = new PrintParameters({
            view: args.view,
            template: printTemplate
          })

          printTask.execute(printParameters).then(
            result => {
              console.log(result);
              resolve(result);
            },
            error => {
              console.log(error);
              reject(error);
            }
          );


        });
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      this.request.makeRequest({
        url: `${this.getPortalUrl()}/sharing/rest/oauth2/signout`,
        handleAs: 'text'
      }).then(
        resp => resolve(resp),
        error => reject(error)
      );
    });
  }
}
